/**
 * region for libraries*/
import React, { Component, Fragment } from 'react';
import ReactApexChart from "react-apexcharts";

/**
 * region for component*/
import { WorkingLayer } from '../../../../components/common/WorkingLayer';

/**
 * region for helpers*/
import ajax from '../../../../helpers/ajax';
import typing from '../../../../helpers/typing';

/**
 * region for constants*/
import Constants from '../../../../constants/Constants'


export class TotalKeywordChart extends Component {
    static displayName = TotalKeywordChart.name;

    constructor(props) {
        super(props);

        this.state = {
            mode: Constants.MODE_LOADING,
            seriesLabel: [],
            options: {
                plotOptions: {
                    bar: {
                        distributed: false,
                    }
                },
                grid: {
                    show: false,
                },
                colors: ['#62e5c4', '#ff0000'],
                responsive: [{
                    breakpoint: 1500,
                    options: {
                        chart: {
                            width: 320,
                            height: 220
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }],
                tooltip: {                    
                    x: {
                        format: 'MMM dd, yyyy:'
                    },
                    y: {
                        formatter: function (val, index) {
                            return typing.numberWithCommas(val);
                        }
                    } 
                },
                chart: {
                    toolbar: {
                        show: false
                    },
                    type: 'line',
                },
                stroke: {
                    width: 4,
                    curve: 'smooth'
                },

                xaxis: {
                    type: 'datetime',
                    categories: [],
                    labels: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                },
                yaxis: {
                    labels: {
                        show: false
                    }
                },
                legend: {
                    show: false,
                    fontWeight: 100
                },
                title: {
                    text: '',
                    align: 'left',
                    margin: 15,
                    floating: true,
                    style: {
                        fontSize: "20px",
                        fontWeight: 100,
                        color: '#666'
                    }
                },
                subtitle: {
                    text: '',
                    margin: 15,
                    floating: true,
                    align: 'left',
                    style: {
                        fontWeight: 100
                    }
                }
            },
            series: [{ name: 'KEYWORDS', data: [] },
                    { name: 'SYNONYMS', data: [] }],
        }
    }
       

    load() {

        const self = this;

        ajax.get(Constants.ROUTE_API_DASHBOARD_TOTAL_KEYWORD_SYNONYM,
            {
                success: function (response) {     

                    let optionsCopy = Object.assign({}, self.state.options);
                    let seriesCopy = [...self.state.series];
                    let seriesKeyword = response.data.map(serie => serie.TOTALKEYWORDS);
                    let seriesSynonym = response.data.map(serie => serie.TOTALTOTALSYNONYMS);
                    let labelsUpdated = response.data.map(label => typing.convertToDateShortMonth(label.LOGDATE));
                    let totalKeywords = response.data[seriesKeyword.length - 1].TOTALKEYWORDS;
                    let totalSynonyms = response.data[seriesSynonym.length - 1].TOTALTOTALSYNONYMS;



                    optionsCopy.xaxis.categories = labelsUpdated;
                    optionsCopy.title.text =  typing.numberWithCommas(totalKeywords)  + "\u00A0\u00A0\u00A0\u00A0" + typing.numberWithCommas(totalSynonyms);
                    optionsCopy.subtitle.text =  `Keywords\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0Synonyms`;

                    seriesCopy[0].data = seriesKeyword;
                    seriesCopy[1].data = seriesSynonym;

                    self.setState({
                        mode: Constants.MODE_LOADED,
                        options: optionsCopy,
                        series: seriesCopy,
                        seriesLabel: labelsUpdated
                    });
                }
            });
    }

    componentDidMount() {
        const self = this;
        self.load();
    }


    render() {

        if (this.state.mode === Constants.MODE_LOADING) {
            return <WorkingLayer />
        }

        return (
            <Fragment>
            <div className="chart-container">
              <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={320}/>
            </div>
          </Fragment>
        )
    }
}



    

   
